import { gsap } from 'gsap';

export function bannerInit(el) {
  gsap.set(el, {
    xPercent: -50,
    y: 20,
    autoAlpha: 0,
  });
}

export function bannerEnter(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, {
      xPercent: -50,
      y: 0,
      autoAlpha: 1,
      ease: 'power3.easeInOut',
      duration: 0.75,
    }, 'start');

  return tl;
}
